// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"93":"list","180":"story"}[chunkId] || chunkId) + "-" + {"93":"dd509edf15637173011c","180":"20eeceafce85f80ce695","205":"8f1952ff70d3f8ea3634","558":"dcea74cd47d7296b63df","566":"89d3921bbe71ecd47167"}[chunkId] + ".css";
};